import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import {initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import CryptoService from "../../../services/crypto-service.js";
import { FormField, SelectField } from './../../common/helper/formFields';

const EditCryptoConfig = () => { 
  const [loading, setLoading] = useState(false);
  const [formData,setFormData] = useState({});
  const userData = useSelector(state => state.authReducer);
  const [errors, setErrors] = useState({ ...initialErrors });
  const navigate = useNavigate();
  const { id } = useParams();

  const [role,setUserRole] = useState();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  }
  const validateField = (fieldName, value) => {
    let errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const updateCryptoConfig = (e) => {
    e.preventDefault();
    let requiredFields = ['buyRate','sellRate','minQty','maxQty'];
    if (!validateFields(requiredFields, formData)) {
        return
      } 
      let request = {
        buy_rate: formData.buyRate,
        sell_rate: formData.sellRate,
        min_quantity: formData.minQty, 
        max_quantity: formData.maxQty
      }
      CryptoService.updateCryptoConfigs(request,id)
          .then(response => {
            setLoading(false);
           
            navigate('/crypto-config')
            toast.success(MESSAGES.CONFIG_UPDATE)
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
  const getCryptoConfigList = (e) => {
    setLoading(true);
    CryptoService.getCryptoconfig(id)
      .then(response => {
        let data = response.data.data
       setFormData({
        buyRate: data.buy_rate,
        sellRate: data.sell_rate,
        minQty: data.min_quantity, 
        maxQty: data.max_quantity
       })
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };

    useEffect(() => {
        getCryptoConfigList()
      setUserRole(userData.user.data.role.role_code.toLowerCase())
      
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);

const back = () => {
    navigate('/crypto-config'); 
  }
return (
<>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
      <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Update Crypto Config</h4>
      <div className="container" style={{backgroundColor: 'white'}}>
  
        <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
          <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <form onSubmit={updateCryptoConfig}>
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{padding: 0}}>
                  
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                 
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {/* <label htmlFor="f_name">AGENT ID</label>
                    <input type="text" className="form-control" id="first_name" defaultValue={2222252524} name="f_name" disabled /> */}
                    <FormField
                        type="text"
                        isRequierd = {true}
                        id="buyRate"
                        name="buyRate"
                        label="BUY RATE"
                        onChange={handleChange}
                        placeholder = "Enter Buy Rate"
                        error={errors.buyRate}
                        value = {formData.buyRate}
                        maxLength={20}
                      />
                  </div>
                 
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                   


                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="number"
                           isRequierd = {true}
                           id="minQty"
                           name="minQty"
                           label="MIN QUANTITY"
                           placeholder = "Enter Min Quantity"
                           value = {formData.minQty}

                           onChange={handleChange}
                           error={errors.minQty}
                          
                        />
                   
                   
                    </div>
                    
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                  
                                 <div className="form-group frm" style={{textAlign: 'left'}}>
                                 <FormField
                           type="text"
                           isRequierd = {true}
                           id="sellRate"
                           name="sellRate"
                           label="SELL RATE"
                           placeholder = "Enter SELL RATE"
                           onChange={handleChange}
                           error={errors.sellRate}
                           value = {formData.sellRate}
                           
                        />
                                 </div>
                  
         
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                   
                    <FormField
                           type="number"
                           isRequierd = {true}
                           id="maxQty"
                           name="maxQty"
                           label="MAX QUANTITY"
                           placeholder = "MAX QUANTITY"
                           value = {formData.maxQty}
                           onChange={handleChange}
                           error={errors.maxQty}
                          
                        />

                    </div>
                    
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="submit" name="btn_admin_details" id="btn_basics_details" className="btn ddfg sebtn">Update</button>
                  <button onClick={back} className="btn btn-success backbt sebtn" style={{'marginBottom':'0px'}}>Back</button>
                </div>
                <br />
              </div>
            </div>
            </form>
          </div>
         
        </div>
      </div>
      
    </div>
    </>
  );

}

 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(EditCryptoConfig));